import React from 'react'
import { InlineButton } from '@fs/zion-ui'
import { FormPhoneNumber } from '@fs/zion-phone-number'
import { Trans, useTranslation } from 'react-i18next'
import { baseUrl } from '@fs/zion-config'

export default function MobileNumberField() {
  const [t] = useTranslation()
  return (
    <FormPhoneNumber
      name="mobile"
      label={`${t('form.mobile-number.label', 'Mobile Number')}:`}
      helpMessage={
        <Trans i18nKey="form.mobile-number.help-message">
          Message and data rates may apply. See{' '}
          <InlineButton
            to={`${baseUrl}/legal/text-messaging-terms-and-conditions`}
            linkName="Form: Mobile Number: Messaging rates"
            target="_blank"
            external
          >
            Text Messaging Terms and Conditions.
          </InlineButton>
        </Trans>
      }
    />
  )
}
